import colorValues from "./colors.module.scss";
import elevationValues from "./elevations.module.scss";
import radiusValues from "./radiuses.module.scss";
import spacingValues from "./spacings.module.scss";
import breakpointValues from "./breakpoints.module.scss";

const colors = [
  "neutral",
  "primary",
  "secondary",
  "success",
  "warning",
  "error",
] as const;

export type TColor = (typeof colors)[number];

const colorWeights = [
  "25",
  "50",
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900",
] as const;

export type TColorWeight = (typeof colorWeights)[number];

export type TColorWithWeights = TColor | `${TColor}-${TColorWeight}`;

export function getColor(name?: TColorWithWeights | string) {
  return name ? colorValues[name] : undefined;
}

const elevations = [
  "xs",
  "sm",
  "md",
  "lg",
  "xl",
  "txs",
  "tsm",
  "tmd",
  "tlg",
  "txl",
] as const;

export type TElevation = (typeof elevations)[number];

export function getElevation(name?: TElevation) {
  return name ? elevationValues[name] : undefined;
}

const radiuses = ["0", "1", "2", "3", "4", "5", "pill", "circle"] as const;

export type TRadius = (typeof radiuses)[number];

export function getRadius(name?: TRadius | string) {
  return name ? radiusValues[name] : undefined;
}

const spacings = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
] as const;

export type TSpacing = (typeof spacings)[number];

export function getSpacing(name?: TSpacing) {
  return name ? spacingValues[name] : undefined;
}

export const breakpoints = ["xs", "sm", "md", "lg", "xl"] as const;

export type TBeakpoint = (typeof breakpoints)[number];

export function getBreakpoint(name?: TBeakpoint) {
  return name ? breakpointValues[name] : undefined;
}

export function getBreakpointGap(name?: TBeakpoint) {
  return name ? breakpointValues[name + "-gap"] : undefined;
}
